import { animate, query, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { faHeart as faHeartEmpty } from '@fortawesome/free-regular-svg-icons';
import { faHeart as faHeartFull } from '@fortawesome/free-solid-svg-icons';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SetRouteService } from 'app/shared/services/set-route/set-route.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { OpenDialogChoiceClubAdminComponent } from '../dialog/open-dialog-choice-club-admin/open-dialog-choice-club-admin.component';
import { OpendialogLoginComponent } from '../dialog/open-dialog-login/opendialog-login.component';
import { OpenDialogSearchMobileComponent } from '../dialog/open-dialog-search-mobile/open-dialog-search-mobile.component';
import { UsersService } from 'app/shared/services/users/users.service';
import { CustomerDetails } from 'app/shared/models/class/user/user';
import { NoticeService } from 'app/shared/services/notice/notice.service';
import { of } from 'rxjs';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  animations: [
    trigger('popUpAnim', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0 }),
          animate('.17s', style({ opacity: 1 })),
        ], { optional: true })
      ]),
      transition(':leave', [
        query('.wrap', [
          style({ opacity: 1 }),
          animate('.17s', style({ opacity: 0 })),
        ], { optional: true })
      ])
    ])
  ]
})
export class NavComponent extends SubscriptionBaseComponent implements OnInit {

  faHeartEmpty = faHeartEmpty;
  faHeartFull = faHeartFull;

  popUpSignIn: boolean;
  isConnectUser: boolean;
  popUpShop: boolean;
  myShoppingBagLength: number;
  myWishesLength: number;
  userConnect: InfosUser;
  welcome: string;
  showTags: boolean;
  showIcons: boolean;
  isDemo: boolean;
  user: CustomerDetails;

  constructor(
    private dataService: DataService,
    public router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private setRouteService: SetRouteService,
    private dialog: MatDialog,
    private faIconService: FaiconService,
    private userService: UsersService,
    private noticeService: NoticeService
  ) {
    super();

    this.subscription.add(
      this.dataService.themeDemo$.subscribe({
        next: isDemo => this.isDemo = isDemo
      })
    );
  }

  ngOnInit(): void {
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  showPopUpSignIn(): void {
    this.dataService.popUpSignIn.next(true);
    this.dataService.popUpShop.next(false);
  }

  showPopUpShopBasket(): void {
    this.dataService.popUpShop.next(true);
    this.dataService.popUpSignIn.next(false);
  }

  getFullOrEmptyWhish(): object {
    return this.myShoppingBagLength === 0 ? this.faHeartEmpty : this.faHeartFull;
  }

  goHome(search: boolean = false): void {
    this.dialog.closeAll();
    const urlHome = sessionStorage.getItem('route') || '/';

    this.router.navigateByUrl(urlHome);

    this.noticeService.detailsImage$.next({ bool: false });

    if (localStorage.getItem('tag_club_id')) {
      const result = JSON.parse(localStorage.getItem('tag_club_id')!);
      this.router.navigate([urlHome], {
        queryParams: {
          universe: result.universe,
          clubKey: result.club,
          tagKey: result.tag
        }
      });
    }
    if (search) {
      this.dialog.open(OpenDialogSearchMobileComponent, {
        width: '110%',
        height: '85%'
      });
    }
  }

  goToWishes(): void {
    const { structure, universe } = this.route.snapshot.queryParams;
    this.router.navigate(['/home/my-wishes'], { queryParams: { structure, universe } });
  }

  isAuth(): boolean {
    return this.authService.isAuth();
  }

  openDialogLogin(): void {
    this.dialog.open(OpendialogLoginComponent);
  }

  isAdmin(): boolean {
    // return ['admin', 'club', 'counter', 'planning'].includes(this.userConnect?.role) ? true : false;
    return ['admin', 'AdminCROS', 'AdminMSR', 'AdminSITE'].includes(this.userConnect?.role);
  }

  goToMenu(menu: string): void {

    const userConnected = this.authService.getDecodedToken();

    switch (menu) {
      case 'counter':
        switch (userConnected.role) {
          case 'admin':
            this.dialog.open(OpenDialogChoiceClubAdminComponent, {
              data: { url: '/admin/counter', title: 'counter' },
              width: '40%',
            });
            break;
          case 'AdminMSR':
          case 'counter':
            this.router.navigate(['/admin/counter']);

            break;

          default:
            break;
        }

        break;
      case 'planing':

        switch (userConnected.role) {
          case 'admin':
            this.dialog.open(OpenDialogChoiceClubAdminComponent, {
              data: { url: '/admin/planning', title: 'planing' },
              width: '40%',
            });
            break;
          case 'AdminMSR':
          case 'planning':
            this.router.navigate(['/admin/planning']);
            break;

          default:
            break;
        }

        break;

      default:
        break;
    }
  }

  private getUserByKey(userKey: number): void {
    this.userService.getUserDetails(userKey).subscribe({
      next: data => {
        this.user = data;
        this.userService.usercurrent$.next(this.user);
      }
    })
  }


  private initSub(): void {
    this.subscription
      .add(
        this.dataService.popUpSignIn.asObservable().subscribe({
          next: popUpSignIn => { this.popUpSignIn = popUpSignIn; this.cdr.detectChanges(); }
        })
      )
      .add(
        this.dataService.popUpShop.asObservable().subscribe({
          next: popUpShop => { this.popUpShop = popUpShop; this.cdr.detectChanges(); }
        })
      )
      .add(
        this.dataService.isConnectUser.asObservable().subscribe({
          next: isConnectUser => { this.isConnectUser = isConnectUser; this.cdr.detectChanges(); }
        })
      ).add(
        this.dataService.myShoppingBag.asObservable().subscribe({
          next: myShoppingBag => { this.myShoppingBagLength = myShoppingBag?.length; this.cdr.detectChanges(); }
        })
      )
      .add(
        this.dataService.myWishes.asObservable().subscribe({
          next: myWishes => { this.myWishesLength = myWishes?.length; this.cdr.detectChanges(); }
        })
      )
      .add(
        this.authService.currentUser.asObservable().subscribe({
          next: user => { this.userConnect = user; }
        })
      )
      .add(
        // distinctUntilChanged + switchMap avoids re-fetching for the same user and cancels stale in-flight requests
        this.authService.currentUser.asObservable().pipe(
          map(user => user ? Number.parseInt(user.sub) : null),
          distinctUntilChanged(),
          switchMap(userKey => userKey !== null ? this.userService.getUserDetails(userKey) : of(null))
        ).subscribe({
          next: data => {
            this.user = data as any;
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.titleWelcome$.subscribe({
          next: welcome => { this.welcome = welcome; this.cdr.detectChanges(); }
        })
      )
      .add(
        this.dataService.showTagSearch$.subscribe({
          next: showTagSearch => {
            this.showTags = showTagSearch;
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.showIcons$.subscribe({
          next: showIcons => {
            this.showIcons = showIcons;
            this.cdr.detectChanges();
          }
        })
      );

  }

}
